import axios from 'axios';
import React, { useState, useEffect } from 'react';
import Dkr_Table from './Dkr_Table';
import CircularProgress from '@mui/material/CircularProgress';
import TestApiClient from '../../LoginData/TestApiClient';
import Box from '@mui/material/Box';

function DkrEnable() {
  const [districts, setDistricts] = useState([]);
  const [distCode, setDistCode] = useState('');
  const [submittedDistCode, setSubmittedDistCode] = useState(''); 
  const [loading, setLoading] = useState(true);
  const [month, setMonth] = useState();
  const [year, setYear] = useState();
  const { getData } = TestApiClient();


  
   useEffect(() => {
    const fetchCurrentAndLoad = async () => {
      try {
        const [mRes, yRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_URL_HEADER}/Common/currentMonth`),
          axios.get(`${process.env.REACT_APP_URL_HEADER}/Common/currentYear`),
        ]);
        let m = Number(mRes?.data?.month ?? mRes?.data);
        let y = Number(yRes?.data?.year ?? yRes?.data);

        setMonth(String(m));
        setYear(String(y));
      } catch {
console.error("error getting month and year")
      }
    };
    fetchCurrentAndLoad();
  }, []);

  useEffect(() => {
    // axios.get(`${process.env.REACT_APP_URL}/api/dkr/initial_data`)
    //   .then((response) => {
    //     setDistricts(response.data.districts);



          getData(`${process.env.REACT_APP_URL}/api/dkr/initial_data`)
          .then((data) => {
        setDistricts(data?.districts ?? []);

      })
      .catch((error) => {
        console.error('Error fetching districts:', error);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = () => {
    if (!distCode) {
      alert('Please select a district.');
      return;
    }
    setSubmittedDistCode(distCode); 
  };

  const getMonthName = (monthNum) => {
    return new Date(2000, monthNum - 1).toLocaleString('default', { month: 'long' });
  };

  return (
    <div>
      <table align='center' width='60%'>
        <thead className='tableheader'>
          <tr>
            <th colSpan={6}>DKR Enable</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Distribution Month</td>
            <td>{getMonthName(month)}</td>
            <td>Distribution Year</td>
            <td>{year}</td>
            <td>District</td>
            <td>
              {loading ? (
                <CircularProgress size={20} />
              ) : (
                <select value={distCode} onChange={e => setDistCode(e.target.value)}>
                  <option value="">Select District</option>
                  {districts.map((item) => (
                    <option key={item.distCode} value={item.distCode}>
                      {item.distNameEn}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td colSpan={6} align='center'>
              <button className='button' onClick={handleSubmit}>Submit</button>
              <button className='button' onClick={() => window.history.back()}>Back</button>
            </td>
          </tr>
        </tbody>
      </table>

      <br />

      {submittedDistCode && <Dkr_Table distCode={submittedDistCode} month={month} year={year}/>}
    </div>
  );
}

export default DkrEnable;
